<div>
  <div class="form-group">
    <span class="title mr-3"> <b> Sub Tasks </b></span>
    <button
      type="button"
      class="btn btn-primary btn-sm"
      *ngIf="!formData.editable"
      (click)="formData.editable = true"
      ><i class="fas fa-plus"></i> Add New</button
    >
  </div>

  <div class="form mb-5" *ngIf="formData.editable">
    <ng-container
      *ngTemplateOutlet="
        taskForm;
        context: {
          task: formData,
        }
      "
    >
    </ng-container>
  </div>
</div>

<div class="d-flex align-items-end">
  <div class="col-md-4">
    <div class="form-group mb-1">
      <label for="">Load from Template</label>
      <ng-select
        [items]="templates"
        [multiple]="false"
        [closeOnSelect]="true"
        bindLabel="template_name"
        [searchable]="true"
        [ngModel]="design.subtask_template"
        (change)="onChangeTemplateFn($event)"
        [hideSelected]="true"
        appendTo="body"
      ></ng-select>
    </div>
  </div>

  <div class="d-flex flex-row-reverse ml-auto">
    <div class="d-flex">
      <label for="" [style.white-space]="'no-wrap'">Sort By</label>
      <select
        class="form-control form-control-sm"
        (change)="sortByPriority($event.target.value)"
      >
        <option value=""></option>
        <option value="1">High - Low</option>
        <option value="0">Low - High</option>
      </select>
    </div>
  </div>
</div>

<div class="sub-tasks">
  <div class="task-section">
    <div class="row">
      <div class="col-md-12">
        <div
          class="list-group column-list"
          cdkDropList
          [cdkDropListData]="subtasks"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            class="list-group-item py-4"
            cdkDrag
            [cdkDragData]="task"
            *ngFor="let task of subtasks; let i = index"
            [ngClass]="{
              high: task.priority == 30,
              medium: task.priority == 20,
              low: task.priority == 10,
            }"
            [ngStyle]="{
              background: task.id == highlightSubtaskId ? '#ffffdf' : '',
            }"
          >
            <div class="sub-task">
              <div class="form-check" *ngIf="!task.editable">
                <div class="actions">
                  <a
                    [class.disabled]="isImporting"
                    (click)="task.editable = true"
                    class="text-info mr-2"
                    href="javascript:void(0);"
                  >
                    <i class="fas fa-edit"></i> Edit</a
                  >
                  <a
                    (click)="deleteSubtask(task, i)"
                    class="text-danger"
                    [class.disabled]="isImporting"
                    href="javascript:void(0);"
                  >
                    <i class="fas fa-trash"></i> Delete</a
                  >
                </div>

                <input
                  [(ngModel)]="task.done"
                  class="form-check-input checkbox-1x"
                  type="checkbox"
                  [checked]="task.done"
                  (change)="toggleCheckbox(task, i)"
                  [id]="task.id"
                />
                <div class="ml-4">
                  <div>
                    <ng-container *ngIf="getDescriptionLength(task.text) <= 90">
                      <span [style.text-decoration]="task.done && 'line-through'">{{
                        task.text
                      }}</span>
                    </ng-container>
                    <ng-container *ngIf="getDescriptionLength(task.text) > 90">
                      <span
                        *ngIf="task.show_all"
                        [style.text-decoration]="task.done && 'line-through'"
                        >{{ task.text }}</span
                      >
                      <span
                        *ngIf="!task.show_all"
                        [style.text-decoration]="task.done && 'line-through'"
                        >{{ task.text | excerpt: 90 }}</span
                      >
                      [
                      <a
                        class="text-expand-link"
                        (click)="task.show_all = !task.show_all"
                        >{{ task.show_all ? 'show less' : 'show more' }}</a
                      >
                      ]
                    </ng-container>
                  </div>
                  <div>
                    <span
                      class="due_date"
                      *ngIf="task.due_date"
                      [ngClass]="{ due: isDateDue(task) }"
                    >
                      <i class="far fa-clock"></i>
                      {{ task.due_date | date: 'MMM d' }}
                    </span>
                    <span class="members" *ngIf="task.assigned_users">
                      <small
                        *ngFor="let assignedUser of task.assigned_users"
                        title="{{
                          assignedUser.user
                            ? assignedUser.user.firstname +
                              ' ' +
                              assignedUser.user.lastname
                            : ''
                        }}"
                      >
                        <span class="user" *ngIf="assignedUser.user">
                          {{
                            (assignedUser.user
                              ? assignedUser.user.firstname.charAt(0)
                              : '') +
                              (assignedUser.user
                                ? assignedUser.user.lastname.charAt(0)
                                : '')
                          }}
                        </span>
                      </small>
                    </span>
                    <span>
                      <small>
                        Added By:
                        <strong class="text-capitalize">{{
                          task?.user?.firstname + ' ' + task?.user?.lastname
                        }}</strong>
                      </small>
                    </span>
                  </div>
                  <div
                    class="attachments"
                    *ngIf="
                      task.assigned_attachments &&
                      task.assigned_attachments.length > 0
                    "
                  >
                    <span
                      class="badge badge--outline-primary m-1"
                      *ngFor="let atta of task.assigned_attachments; let i = index"
                    >
                      <a
                        (click)="viewAttachment(atta)"
                        class=""
                        href="javascript:void(0);"
                      >
                        <i class="fa fa-paperclip mr-1" aria-hidden="true"></i
                        >{{ atta.fileurl }}
                      </a>
                      <a
                        href="javascript:;"
                        class="ml-1 text-danger"
                        title="Remove"
                        (click)="deleteAttachment(task, atta.id, i)"
                      >
                        <i class="fas fa-times"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-check" *ngIf="task.editable">
                <ng-container
                  *ngTemplateOutlet="
                    taskForm;
                    context: {
                      task: task,
                    }
                  "
                >
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template let-task="task" #taskForm>
  <div class="row">
    <div class="col-md-12">
      <textarea [(ngModel)]="task.text" class="form-control textarea"></textarea>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4">
      <div class="form-group mb-1">
        <label for="">Icon</label>
        <a
          href="javascript:;"
          class="form-control"
          (click)="getIcon(task)"
          title="Set Icon"
        >
          Browse... <mat-icon class="selected-icon">{{ task.icon }}</mat-icon>
        </a>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label for="">Priority</label>
        <select type="text" class="form-control" [(ngModel)]="task.priority">
          <option value=""></option>
          <option value="10">Low</option>
          <option value="20">Medium</option>
          <option value="30">High</option>
        </select>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form-group mb-1">
        <label for="">Due Date</label>
        <input type="date" [(ngModel)]="task.due_date" class="form-control" />
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-8">
      <div class="form-group mb-1">
        <label for="">Assign To</label>
        <ng-select
          [items]="staffSvc.assignee$ | async"
          [multiple]="true"
          [closeOnSelect]="true"
          bindLabel="firstname"
          bindValue="id"
          [searchable]="true"
          [(ngModel)]="task.assigned_user_ids"
          [hideSelected]="true"
          appendTo="body"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">
              {{ item.firstname }} {{ item.lastname }}
            </span>
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
              >×</span
            >
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <div>{{ item.firstname }} {{ item.lastname }}</div>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </div>

  <span
    class="badge badge--outline-primary m-1"
    *ngFor="let file of task.filesToUpload; let i = index"
  >
    {{ file.file.name }}
    <a
      href="javascript:;"
      class="ml-1 text-danger"
      title="Remove"
      (click)="task.filesToUpload.splice(i, 1)"
    >
      <i class="fas fa-times"></i>
    </a>
  </span>

  <div class="mt-2">
    <button
      [disabled]="isImporting"
      class="btn btn-primary btn-sm"
      (click)="saveTask(task)"
      type="button"
    >
      <span *ngIf="!isImporting">Save</span>
      <mat-spinner [diameter]="18" *ngIf="isImporting"></mat-spinner>
    </button>

    <!-- <button [disabled]="isImporting" class="btn btn-outline-secondary btn-sm ml-1" (click)="saveTemplate(task)" type="button">
			<span *ngIf="!isImporting">Save as Template</span>
			<mat-spinner [diameter]="18" *ngIf="isImporting"></mat-spinner>
		</button> -->

    <button
      [disabled]="isImporting"
      class="btn btn-outline-primary btn-sm ml-1"
      (click)="clearTaskForm(task)"
      type="button"
    >
      <span>Cancel</span>
    </button>

    <input
      type="file"
      hidden
      #subtaskUploader
      class="form-control"
      id="subtask-files"
      multiple
      (change)="handleSubtaskFiles($event, task)"
    />

    <button
      [disabled]="isImporting"
      (click)="subtaskUploader.click()"
      class="btn btn-outline-primary btn-sm float-right"
      type="button"
    >
      <i class="fa fa-paperclip" aria-hidden="true"></i>
    </button>
  </div>
</ng-template>
